<script lang="ts">
	import {
		relayPriorityCloseChrome,
		relayPriorityDevForce,
		setRelayPriorityCloseChrome,
		setRelayPriorityDevForce,
	} from 'src/stores/features/dev/relay-priority-dev-state';
	import PriorityLayoutDevHud from 'src/components/Sidepanel/PriorityLayoutDevHud.svelte';
	import {
		RELAY_CLOSE_CHROME_DEV_OPTIONS,
		RELAY_PRIORITY_DEV_OPTIONS,
		type RelayCloseChrome,
		type RelayPriorityDevForce,
	} from 'src/helpers/relay_priority_layout';

	const onSelect = (id: string) => {
		setRelayPriorityDevForce(id as RelayPriorityDevForce);
	};

	const onExtraSelect = (id: string) => {
		setRelayPriorityCloseChrome(id as RelayCloseChrome);
	};
</script>

<PriorityLayoutDevHud
	options={RELAY_PRIORITY_DEV_OPTIONS}
	selectedId={$relayPriorityDevForce}
	idPrefix="relay-priority-dev"
	extraOptions={RELAY_CLOSE_CHROME_DEV_OPTIONS}
	extraSelectedId={$relayPriorityCloseChrome}
	extraGroupLabel="Close chrome"
	{onSelect}
	{onExtraSelect}
/>
